<template>
  <v-layout row wrap>
    <v-flex
      xs12
      mb-3
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.Objective') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <div>
                <img :src="objectiveType.websiteVisits.imageUrl" class="imageIcon">
              </div>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ $t('message.bizgainOnboarding.summaryPage.websiteVisitsObjective') }}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-3
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.destinationUrl') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout v-if="!isEditDestinationUrl">
            <v-flex xs1>
              <v-icon class="greyIcon">
                language
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="ml-1 label detail-field">
                {{ websiteVisitDestinationUrl }}
              </span>
            </v-flex>
            <v-flex xs2>
              <v-icon class="editIcon" @click="isEditDestinationUrl = true">
                edit
              </v-icon>
            </v-flex>
          </v-layout>
          <v-layout v-if="isEditDestinationUrl">
            <v-flex xs12>
              <v-card class="pa-2 mt-2">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      type="url"
                      v-model="websiteVisitDestinationUrl"
                      placeholder="Ex: https://yourwebsite.com"
                      name="websiteVisitLink"
                      class="py-0 ma-0"
                      v-validate="'required|url'"
                      data-vv-validate-on="blur"
                      @focus="clearErrorByField($event, 'websiteVisitLink')"
                      :error-messages="
                        errors.first('websiteVisitLink')
                          ? $t(
                            'message.bizgainOnboarding.websiteUrlValidationMessage'
                          )
                          : null
                      "
                    />
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-btn
                      depressed
                      :disabled="errors.items.length > 0"
                      :loading="isLoadingDestinationUrl"
                      class="mx-0 next-btn-color next-btn-xs"
                      @click="updateDestinationUrl()"
                    >
                      Save
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-1
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.ServicesPromoted') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout v-if="!isEditPromoteServices">
            <v-flex xs1>
              <v-icon class="greyIcon">
                home_repair_service
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field">
                {{ selectedServicesString }}
              </span>
            </v-flex>
            <v-flex xs2>
              <v-icon class="editIcon" @click="isEditPromoteServices = !isEditPromoteServices">
                edit
              </v-icon>
            </v-flex>
          </v-layout>
          <v-layout v-if="isEditPromoteServices">
            <v-flex xs12>
              <v-card class="pa-2 mt-2">
                <v-layout row wrap class="promote-services">
                  <v-flex
                    xs12
                  >
                    <div>
                      <v-autocomplete
                        class="pt-0 mt-0"
                        v-model="selectedServices"
                        :items="allServices"
                        item-text="name"
                        item-value="id"
                        :placeholder="`Ex: ${allServices[0].name }`"
                        name="selectedServices"
                        v-validate="'required'"
                        @focus="clearErrorByField($event, 'selectedServices')"
                        :error="errors.has('selectedServices')"
                        :error-messages="
                          errors.first('selectedServices')
                            ? $t(
                              'message.bizgainOnboarding.selectedServiceWarning')
                            : null
                        "
                        small-chips
                        multiple
                        append-icon="keyboard_arrow_down"
                        :return-object="true"
                        :menu-props="{ maxHeight: 200 }"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            color="primary-transperant-variant"
                            text-color="black"
                            class="selected-services"
                            :selected="data.selected"
                          >
                            <span
                              class="selected-service-item"
                            >{{ data.item.name }}
                              <v-icon
                                small
                                class="
                              pr-1"
                                right
                                color="black"
                                @click="removeSelectedService(data.item)"
                              >
                                close
                              </v-icon>
                            </span>
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-flex>
                  <v-layout v-if="selectedServices.length > 1">
                    <alert
                      :icon-color="'primary'"
                      :icon-width="`${ !$vuetify.breakpoint.xsOnly ? 'xs1' : 'xs2' }`"
                      :outline="true"
                      :outline-color="'primary'"
                      :message="$t('message.bizgainOnboarding.promoteServiceAlert')"
                      :col-width="'xs12 sm10'"
                    />
                  </v-layout>
                  <v-flex xs12 md3>
                    <v-btn
                      depressed
                      :disabled="!isServiceSelected || errors.items.length > 0"
                      :loading="isLoadingUpdatePromoteServices"
                      class="mx-0 next-btn-color next-btn-xs"
                      @click="updateSelectedServices()"
                    >
                      Save
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-1
      v-if="false"
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.PromotionTag') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <v-icon class="greyIcon">
                local_offer
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field">
                {{ offerTagline }}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  VLayout,
  VFlex,
  VIcon,
  VTextField,
  VAutocomplete,
  VChip,
  VCard
} from 'vuetify/lib';
import Alert from 'Components/Alert/Alert';
import clearErrorByField from 'Mixins/clearErrorByField';
import { Chat } from 'Mixins/chat';
import { objectiveType, bizgainOnboardingRoutes } from 'Features/bizgainOnboarding/constants';
import { mapGetters, mapActions } from 'vuex';
import { i18n } from '@/lang/';

export default {
  mixins: [clearErrorByField, Chat],
  components: {
    VLayout,
    VFlex,
    VIcon,
    VTextField,
    Alert,
    VAutocomplete,
    VChip,
    VCard
  },
  props: [
    'destinationUrl',
    'offerTagline'
  ],
  data() {
    return {
      objectiveType,
      bizgainOnboardingRoutes,
      isEditDestinationUrl: false,
      websiteVisitDestinationUrl: null,
      isLoadingDestinationUrl: false,
      newBusinessDetails: null,
      isEditPromoteServices: false,
      isLoadingUpdatePromoteServices: false,
      allServices: [],
      selectedServices: []
    }
  },
  created(){
    if (this.businessDetails.websiteVisitDestinationUrl){
      this.websiteVisitDestinationUrl = this.businessDetails.websiteVisitDestinationUrl;
    }
    else if (this.businessDetails.websiteUrl){
      this.websiteVisitDestinationUrl = this.businessDetails.websiteUrl;
    }
    if (!this.websiteVisitDestinationUrl){
      if (this.googlePlaceDetails && this.googlePlaceDetails.website) {
        this.websiteVisitDestinationUrl = this.googlePlaceDetails.website;
      }
      else if (this.facebookPageDetails && this.facebookPageDetails.website) {
        this.websiteVisitDestinationUrl = this.facebookPageDetails.website;
      }
    }
    this.allServices = this.services.map(function(val, index){
      return { id: index, name: val };
    });
    if (this.promoteServices){
      this.promoteServices.forEach(promoteService => {
        let selectedService = this.allServices.find(service => service.name === promoteService);
        if (selectedService) {
          this.selectedServices.push(selectedService)
        }
      });
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'googlePlaceDetails', 'facebookPageDetails', 'promoteServices', 'services']),
    selectedServicesString(){
      return this.promoteServices.join(', ');
    },
    isServiceSelected() {
      return this.selectedServices.length > 0;
    }
  },
  methods: {
    ...mapActions(['patchBusinessDetails']),
    async updateDestinationUrl(){
      try {
        this.isLoadingDestinationUrl = true;
        if(this.businessDetails){
          this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
          var selectedObjectiveType = null;
          this.newBusinessDetails.websiteVisitDestinationUrl = this.websiteVisitDestinationUrl;
          selectedObjectiveType = i18n.tc(objectiveType.websiteVisits.conversionTitle);
          await this.updateUserProperties({ objectiveType: selectedObjectiveType });
          let payload = {
            sessionId: this.businessDetails.sessionId,
            oldBusinessDetails: this.businessDetails,
            newBusinessDetails: this.newBusinessDetails
          };
          await this.patchBusinessDetails(payload);
          this.isLoadingDestinationUrl = false;
          this.isEditDestinationUrl = false;
          if(!this.isError){
            this.isLoadingDestinationUrl = false;
          }
        }
      }
      catch {
        this.isLoadingDestinationUrl = false;
      }
    },
    goToSelectObjective(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.SelectObjective.name, params: { isAppFlow: true } });
    },
    goToPromotedServices(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.PromoteServices.name, params: { isAppFlow: true } });
    },
    goToOfferDetails(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.ExtractOfferDetails.name, params: { isAppFlow: true } });
    },
    removeSelectedService (service) {
      this.selectedServices.splice(this.selectedServices.indexOf(service), 1);
    },
    async updateSelectedServices() {
      if (this.selectedServices){
        try {
          if (this.businessDetails){
            this.isUpdatePromoteServices = true;
            this.isLoadingUpdatePromoteServices = true;
            this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
            if (this.newBusinessDetails && this.newBusinessDetails.creativeDetail) {
              this.newBusinessDetails.creativeDetail.promoteServices = this.selectedServices.map(service=>service.name);
              let payload = {
                sessionId: this.businessDetails.sessionId,
                oldBusinessDetails: this.businessDetails,
                newBusinessDetails: this.newBusinessDetails
              };
              await this.patchBusinessDetails(payload);
              this.isLoadingUpdatePromoteServices = false;
              this.isEditPromoteServices = false;
              if(this.isError){
                this.isLoadingUpdatePromoteServices = false;
              }
            }
          }
        }
        catch {
          this.isLoadingUpdatePromoteServices = false;
          this.isEditPromoteServices = false;
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.themedIcon{
  color: #13abb1;
}
.greyIcon{
  color: #727891;
}
.editIcon{
  color: #13abb1;
}
.imageIcon{
  height: 28px;
  width: 25px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.detail-field{
  color: black;
  align-self: center;
}
@media only screen and (max-width: 600px) {
  .editIcon{
    color: #727891;
  }
}
.selected-services.v-chip {
    height: auto !important;
}

::v-deep .selected-services.v-chip .v-chip__content{
  height: auto !important;
}

::v-deep .selected-service-item {
  white-space: initial !important;
}
</style>

